import fetch from "auth/FetchInterceptor"

const AffiliateManagementService = {

  // Ban account 
  bannedAccount: (id, argument) => {
    return fetch({
      data: { argument },
      method: "post",
      url: `/affiliateManagement/bannedAccount/${id}`,
    })
  },

  // Admin-only creation
  create: (data) => {
    return fetch({
      data,
      method: "post",
      url: "/affiliateManagement/create",
    })
  },

  // Delete by ID
  deleteById: (id) => {
    return fetch({
      method: "delete",
      url: `/affiliateManagement/deleteById/${id}`,
    })
  },

  // Get all 
  getAll: ({ limit, page = 1, status } = {}) => {
    let url = `/affiliateManagement/getAll?page=${page}`

    if (limit) url += `&limit=${limit}`
    if (status) url += `&status=${status}`

    return fetch({
      method: "get",
      url,
    })
  },

  // Get by ID
  getById: (id) => {
    return fetch({
      method: "get",
      url: `/affiliateManagement/getById/${id}`,
    })
  },
  
  // Search helper
  search: ({ fullName, page = 1, status }) => {
    let url = `/affiliateManagement/getAll?page=${page}`

    if (fullName) url += `&fullName=${fullName}`
    if (status) url += `&status=${status}`

    return fetch({
      method: "get",
      url,
    })
  },

  // Update by ID
  update: (id, data) => {
    return fetch({
      data,
      method: "put",
      url: `/affiliateManagement/update/${id}`,
    })
  },

  // Update affiliate status only
  updateStatus: (id, status) => {
    return fetch({
      data: { status },
      method: "put",
      url: `/affiliateManagement/updateStatus/${id}`,
    })
  },

  // Validate account
  validateAccount: (id) => {
    return fetch({
      method: "post",
      url: `/affiliateManagement/validateAccount/${id}`,
    })
  },
}

export default AffiliateManagementService
